import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangeFieldCompany extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  fieldcompany_id: "",
                  fieldcompany_link: "",
                  fieldcompany_priority: "",
                  fieldcompany_genuine_wage: "",
                  fieldcompany_issuing_percent: "",
                  fieldcompany_wage: "",
                  fieldcompany_desc: "",
                  selectedFieldinsurance: "",
                  selectedFilterFieldinsurance: { value: 0, label: "همه رشته های بیمه", logo: "" },
                  selectedCompany: "",
                  selectedFilterCompany: { value: 0, label: "همه شرکت های بیمه", logo: "" },
                  fieldcompany_deactive: "0",
                  company_logo_url: "",
                  fieldinsurance_logo_url: "",
                  orderBy: "fieldcompany_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newFieldCompany: true,
                  optionCompany: [],
                  optionFilterCompany: [{ value: 0, label: "همه شرکت های بیمه", logo: "" }],
                  optionFieldinsurance: [],
                  optionFilterFieldinsurance: [{ value: 0, label: "همه رشته های بیمه", logo: "" }],
            }
      }

      handleChangeLink = (event) => {
            this.setState({ fieldcompany_link: event.target.value })
      }

      handleChangeGeniusWage = (event) => {
            this.setState({ fieldcompany_genuine_wage: event.target.value })
      }
      handleChangeIssuingPercent = (event) => {
            this.setState({ fieldcompany_issuing_percent: event })
      }

      handleChangeWage = (event) => {
            this.setState({ fieldcompany_wage: event.target.value })
      }

      handleChangePriority = (event) => {
            this.setState({ fieldcompany_priority: event.target.value })
      }

      handleChangeDesc = (event) => {
            this.setState({ fieldcompany_desc: event.target.value })
      }

      handleFieldinsurance = (selectedFieldinsurance) => {
            this.setState({ selectedFieldinsurance: selectedFieldinsurance, fieldinsurance_logo_url: selectedFieldinsurance.logo })
      }

      handleFilterFieldinsurance = (selectedFilterFieldinsurance) => {
            this.setState({ selectedFilterFieldinsurance: selectedFilterFieldinsurance }, () => {
                  this.filterFieldCompany()
            })
      }
      handleCompany = (selectedCompany) => {
            this.setState({ selectedCompany: selectedCompany, company_logo_url: selectedCompany.logo })
      }

      handleFilterCompany = (selectedFilterCompany) => {
            this.setState({ selectedFilterCompany: selectedFilterCompany }, () => {
                  this.filterFieldCompany()
            })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ fieldcompany_deactive: "0" })
            } else {
                  this.setState({ fieldcompany_deactive: "1" })
            }
      }

      handleSelectRows = (row2) => {
            this.setState(
                {
                      fieldcompany_id: row2.fieldcompany_id,
                      fieldcompany_link: row2.fieldcompany_link,
                      fieldcompany_genuine_wage: row2.fieldcompany_genuine_wage,
                      fieldcompany_issuing_percent: row2.fieldcompany_issuing_percent,
                      fieldcompany_wage: row2.fieldcompany_wage,
                      fieldcompany_priority: row2.fieldcompany_priority,
                      fieldcompany_desc: row2.fieldcompany_desc,
                      selectedFieldinsurance: {
                            value: row2.fieldcompany_fieldinsurance_id,
                            label: row2.fieldinsurance_fa,
                            logo: row2.fieldinsurance_logo_url,
                      },
                      selectedCompany: { value: row2.fieldcompany_company_id, label: row2.company_name, logo: row2.company_logo_url },
                      fieldcompany_deactive: row2.fieldcompany_deactive,
                      company_logo_url: row2.company_logo_url,
                      fieldinsurance_logo_url: row2.fieldinsurance_logo_url,
                      newFieldCompany: false,
                },
                () => {}
            )
      }

      newFieldCompany = (event) => {
            this.setState({
                  fieldcompany_id: "",
                  fieldcompany_link: "",
                  fieldcompany_genuine_wage: "",
                  fieldcompany_issuing_percent: "",
                  fieldcompany_wage: "",
                  fieldcompany_priority: "",
                  fieldcompany_desc: "",
                  selectedFieldinsurance: "",
                  selectedCompany: "",
                  fieldcompany_deactive: "0",
                  company_logo_url: "",
                  fieldinsurance_logo_url: "",
                  newFieldCompany: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getFieldCompany()
                                    self.getoptionCompany()
                                    self.getoptionFieldinsurance()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getFieldCompany() {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {
                                    self.filterFieldCompany()
                              })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldcompany")

            xhttp.open("POST", `${constants.BASE_URL}/fieldcompany`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionCompany = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              var Company1 = [{ value: 0, label: "همه شرکت های بیمه", logo: "" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].company_id,
                                          label: arr.data[k].company_name,
                                          logo: arr.data[k].company_logo_url,
                                    })
                                    Company1.push({
                                          value: arr.data[k].company_id,
                                          label: arr.data[k].company_name,
                                          logo: arr.data[k].company_logo_url,
                                    })
                              }
                              self.setState({ optionCompany: Company, optionFilterCompany: Company1, selectedFilterCompany: Company1[0] }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_company")
            xhttp.open("POST", `${constants.BASE_URL}/company`)
            xhttp.send(fd)
      }

      getoptionFieldinsurance = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              var Company = []
                              var Company1 = [{ value: 0, label: "همه رشته های بیمه", logo: "" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].fieldinsurance_id,
                                          label: arr.data[k].fieldinsurance_fa,
                                          logo: arr.data[k].fieldinsurance_logo_url,
                                    })
                                    Company1.push({
                                          value: arr.data[k].fieldinsurance_id,
                                          label: arr.data[k].fieldinsurance_fa,
                                          logo: arr.data[k].fieldinsurance_logo_url,
                                    })
                              }
                              self.setState(
                                  {
                                        optionFieldinsurance: Company,
                                        optionFilterFieldinsurance: Company1,
                                        selectedFilterFieldinsurance: Company1[0],
                                  },
                                  () => {}
                              )
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldinsurance")
            xhttp.open("POST", `${constants.BASE_URL}/fieldinsurance`)
            xhttp.send(fd)
      }

      saveNewFieldCompany = () => {
            const {
                  fieldcompany_link,
                  fieldcompany_genuine_wage,
                  fieldcompany_issuing_percent,
                  fieldcompany_wage,
                  fieldcompany_priority,
                  fieldcompany_desc,
                  selectedFieldinsurance,
                  selectedCompany,
                  fieldcompany_deactive,
            } = this.state
            if (selectedFieldinsurance != "" && selectedCompany != "") {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getFieldCompany()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_fieldcompany")
                  fd.append("fieldcompany_link", fieldcompany_link)
                  fd.append("fieldcompany_genuine_wage", fieldcompany_genuine_wage)
                  fd.append("fieldcompany_issuing_percent", fieldcompany_issuing_percent)
                  fd.append("fieldcompany_wage", fieldcompany_wage)
                  fd.append("fieldcompany_priority", fieldcompany_priority)
                  fd.append("fieldcompany_desc", fieldcompany_desc)
                  fd.append("fieldcompany_fieldinsurance_id", selectedFieldinsurance.value)
                  fd.append("fieldcompany_company_id", selectedCompany.value)
                  fd.append("fieldcompany_deactive", fieldcompany_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/fieldcompany`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات شرکت و رشته بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      changeFieldCompany = () => {
            const {
                  fieldcompany_id,
                  fieldcompany_link,
                  fieldcompany_genuine_wage,
                  fieldcompany_issuing_percent,
                  fieldcompany_wage,
                  fieldcompany_priority,
                  fieldcompany_desc,
                  selectedFieldinsurance,
                  selectedCompany,
                  fieldcompany_deactive,
            } = this.state
            if (selectedFieldinsurance != "" && selectedCompany != "") {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getFieldCompany()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "modify_fieldcompany")
                  fd.append("fieldcompany_id", fieldcompany_id)
                  fd.append("fieldcompany_link", fieldcompany_link)
                  fd.append("fieldcompany_genuine_wage", fieldcompany_genuine_wage)
                  fd.append("fieldcompany_issuing_percent", fieldcompany_issuing_percent)
                  fd.append("fieldcompany_wage", fieldcompany_wage)
                  fd.append("fieldcompany_priority", fieldcompany_priority)
                  fd.append("fieldcompany_desc", fieldcompany_desc)
                  fd.append("fieldcompany_fieldinsurance_id", selectedFieldinsurance.value)
                  fd.append("fieldcompany_company_id", selectedCompany.value)
                  fd.append("fieldcompany_deactive", fieldcompany_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/fieldcompany`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات شرکت و رشته بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                i,
                j,
                temp,
                a,
                b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }
      filterFieldCompany = () => {
            const { selectedFilterFieldinsurance, selectedFilterCompany, requestinfos } = this.state
            var temparray = requestinfos,
                temparray2 = [],
                i
            for (i = 0; i < temparray.length; i++) {
                  if (
                      (selectedFilterCompany.value === 0 || temparray[i].fieldcompany_company_id === selectedFilterCompany.value) &&
                      (selectedFilterFieldinsurance.value === 0 ||
                          temparray[i].fieldcompany_fieldinsurance_id === selectedFilterFieldinsurance.value)
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      render() {
            const { classes } = this.props
            const {
                  optionCompany,
                  optionFilterCompany,
                  optionFieldinsurance,
                  optionFilterFieldinsurance,
                  snackMode,
                  snackstr,
                  showSnack,
                  newFieldCompany,
                  fieldcompany_id,
                  fieldcompany_link,
                  fieldcompany_genuine_wage,
                  fieldcompany_issuing_percent,
                  fieldcompany_wage,
                  fieldcompany_priority,
                  fieldcompany_desc,
                  selectedFieldinsurance,
                  selectedFilterFieldinsurance,
                  company_logo_url,
                  fieldinsurance_logo_url,
                  selectedCompany,
                  selectedFilterCompany,
                  fieldcompany_deactive,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                      <div className={classes.paperrtl} dir="ltr">
                            <Snackbar
                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                onClose={this.handleClickcloseTasckBar}
                                open={showSnack}
                                autoHideDuration={10000}
                            >
                                  <Alert severity={snackMode}>{snackstr}</Alert>
                            </Snackbar>
                            <Grid container spacing={3}>
                                  <Grid item xs={12}>
                                        <Container component="main" maxWidth="lg">
                                              <Paper elevation={4} className={classes.root}>
                                                    <Grid container spacing={3}>
                                                          <Grid item xs={6}>
                                                                <Typography align="center" variant="h7">
                                                                      {"شماره کارمند: " + fieldcompany_id}
                                                                </Typography>
                                                          </Grid>
                                                          <Grid item xs={6}></Grid>

                                                          <Grid item xs={6}>
                                                                <div style={{ width: "100%", textAlign: "center" }}>
                                                                      <img
                                                                          alt="Remy Sharp"
                                                                          className={classes.large}
                                                                          src={fieldinsurance_logo_url}
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <div style={{ width: "100%", textAlign: "center" }}>
                                                                      <img alt="Remy Sharp" className={classes.large} src={company_logo_url} />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <div>
                                                                      <label className="on">رشته بیمه</label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"رشته بیمه"}
                                                                          value={selectedFieldinsurance}
                                                                          onChange={this.handleFieldinsurance}
                                                                          options={optionFieldinsurance}
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <div>
                                                                      <label className="on">شرکت بیمه</label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"شرکت بیمه"}
                                                                          value={selectedCompany}
                                                                          onChange={this.handleCompany}
                                                                          options={optionCompany}
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <FloatingLabelInput
                                                                    placeholder="لینک خارجی"
                                                                    handleInputt={this.handleChangeLink}
                                                                    value={fieldcompany_link}
                                                                />
                                                          </Grid>
                                                          <Grid item xs={6}>
                                                                <FloatingLabelInput
                                                                    placeholder="توضیحات"
                                                                    handleInputt={this.handleChangeDesc}
                                                                    value={fieldcompany_desc}
                                                                />
                                                          </Grid>
                                                          <Grid item xs={6}>
                                                                <FloatingLabelInput
                                                                    placeholder="اولویت"
                                                                    handleInputt={this.handleChangePriority}
                                                                    value={fieldcompany_priority}
                                                                />
                                                          </Grid>
                                                          <Grid item xs={6}>
                                                                <FloatingLabelInput
                                                                    placeholder="کارمزد"
                                                                    handleInputt={this.handleChangeWage}
                                                                    value={fieldcompany_wage}
                                                                />
                                                          </Grid>
                                                          <Grid item xs={6}>
                                                                <FloatingLabelInput
                                                                    placeholder="کارمزد حقیقی"
                                                                    handleInputt={this.handleChangeGeniusWage}
                                                                    value={fieldcompany_genuine_wage}
                                                                />
                                                          </Grid>
                                                          <Grid item xs={6}>
                                                                <FloatingLabelInput
                                                                    type="percent"
                                                                    placeholder="درصد حق صدور"
                                                                    handleInputt={this.handleChangeIssuingPercent}
                                                                    value={fieldcompany_issuing_percent}
                                                                />
                                                            </Grid>

                                                          <Grid item xs={6}>
                                                                <div style={{ width: "100%", textAlign: "center" }}>
                                                                      <FormControlLabel
                                                                          control={
                                                                                <Switch
                                                                                    checked={fieldcompany_deactive === "0" ? true : false}
                                                                                    onChange={this.handleChangeDeactive}
                                                                                    name="gilad"
                                                                                />
                                                                          }
                                                                          label="وضعیت رشته بیمه"
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={12}>
                                                                {newFieldCompany ? (
                                                                    <Button variant="outlined" color="primary" onClick={this.saveNewFieldCompany}>
                                                                          {"ثبت رشته و شرکت جدید "}
                                                                    </Button>
                                                                ) : (
                                                                    <div style={{ width: "100%", textAlign: "right" }}>
                                                                          <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={this.newFieldCompany}
                                                                          >
                                                                                {"رشته و شرکت جدید "}
                                                                          </Button>
                                                                          {"          "}
                                                                          <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={this.changeFieldCompany}
                                                                          >
                                                                                {"ثبت تغییرات"}
                                                                          </Button>
                                                                    </div>
                                                                )}
                                                          </Grid>
                                                    </Grid>
                                              </Paper>
                                        </Container>
                                  </Grid>

                                  <Grid item xs={12}>
                                        <Container maxWidth="lg">
                                              <Paper className={classes.root}>
                                                    <Grid container spacing={3}>
                                                          <Grid item xs={6}>
                                                                <div>
                                                                      <label className="on">رشته بیمه</label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"رشته بیمه"}
                                                                          value={selectedFilterFieldinsurance}
                                                                          onChange={this.handleFilterFieldinsurance}
                                                                          options={optionFilterFieldinsurance}
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <div>
                                                                      <label className="on">شرکت بیمه</label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"شرکت بیمه"}
                                                                          value={selectedFilterCompany}
                                                                          onChange={this.handleFilterCompany}
                                                                          options={optionFilterCompany}
                                                                      />
                                                                </div>
                                                          </Grid>
                                                    </Grid>
                                              </Paper>
                                        </Container>
                                  </Grid>

                                  <Grid item xs={12}>
                                        <Container maxWidth="lg">
                                              <Paper className={classes.root}>
                                                    <TableContainer dir="rtl">
                                                          <Table aria-label="sticky table">
                                                                <TableHead>
                                                                      <TableRow>
                                                                            <TableCell
                                                                                key={"fieldcompany_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 20 }}
                                                                                sortDirection={orderBy === "fieldcompany_id" ? order : false}
                                                                            >
                                                                                  {" آی دی رشته و شرکت"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "fieldcompany_id"}
                                                                                      direction={orderBy === "fieldcompany_id" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("fieldcompany_id")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"company_name"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"شرکت بیمه  "}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "company_name"}
                                                                                      direction={orderBy === "company_name" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("company_name")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell></TableCell>

                                                                            <TableCell
                                                                                key={"fieldinsurance_fa"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {" رشته بیمه  "}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "fieldinsurance_fa"}
                                                                                      direction={orderBy === "fieldinsurance_fa" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("fieldinsurance_fa")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>
                                                                            <TableCell></TableCell>
                                                                            <TableCell
                                                                                key={"fieldcompany_priority"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 20 }}
                                                                            >
                                                                                  {"اولویت"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "fieldcompany_priority"}
                                                                                      direction={
                                                                                            orderBy === "fieldcompany_priority" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("fieldcompany_priority")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"fieldcompany_wage"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 20 }}
                                                                            >
                                                                                  {"کارمزد"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "fieldcompany_wage"}
                                                                                      direction={
                                                                                            orderBy === "fieldcompany_wage" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("fieldcompany_wage")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"fieldcompany_genuine_wage"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 20 }}
                                                                            >
                                                                                  {"کارمزد حقیقی"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "fieldcompany_genuine_wage"}
                                                                                      direction={
                                                                                            orderBy === "fieldcompany_genuine_wage" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("fieldcompany_genuine_wage")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"fieldcompany_deactive"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 20 }}
                                                                            >
                                                                                  {"وضعیت رشته شرکت"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "fieldcompany_deactive"}
                                                                                      direction={
                                                                                            orderBy === "fieldcompany_deactive" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("fieldcompany_deactive")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>
                                                                      </TableRow>
                                                                </TableHead>

                                                                <TableBody>
                                                                      {agentInfofilter
                                                                          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                          .map((row) => {
                                                                                return (
                                                                                    <TableRow
                                                                                        hover
                                                                                        role="checkbox"
                                                                                        tabIndex={-1}
                                                                                        key={row["fieldcompany_id"]}
                                                                                        value={row}
                                                                                        onClick={() => {
                                                                                              this.handleSelectRows(row)
                                                                                        }}
                                                                                    >
                                                                                          <TableCell key={"fieldcompany_id"} align={"center"}>
                                                                                                {row["fieldcompany_id"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"company_name"} align={"center"}>
                                                                                                {row["company_name"]}
                                                                                          </TableCell>

                                                                                          <TableCell>
                                                                                                <img
                                                                                                    className={classes.small}
                                                                                                    alt="Remy Sharp"
                                                                                                    src={row["company_logo_url"]}
                                                                                                />
                                                                                          </TableCell>

                                                                                          <TableCell key={"fieldinsurance_fa"} align={"center"}>
                                                                                                {row["fieldinsurance_fa"]}
                                                                                          </TableCell>

                                                                                          <TableCell>
                                                                                                <img
                                                                                                    className={classes.small}
                                                                                                    alt="Remy Sharp"
                                                                                                    src={row["fieldinsurance_logo_url"]}
                                                                                                />
                                                                                          </TableCell>

                                                                                          <TableCell>{row["fieldcompany_priority"]}</TableCell>

                                                                                          <TableCell>{row["fieldcompany_wage"]}</TableCell>
                                                                                          <TableCell>{row["fieldcompany_genuine_wage"]}</TableCell>


                                                                                          <TableCell
                                                                                              key={"fieldcompany_deactive"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["fieldcompany_deactive"] === "1" ||
                                                                                                row["fieldcompany_deactive"] === 1 ? (
                                                                                                    <Fab variant="extended">
                                                                                                          <VoiceOverOffIcon />
                                                                                                          {"غیر فعال"}
                                                                                                    </Fab>
                                                                                                ) : (
                                                                                                    <Fab
                                                                                                        variant="extended"
                                                                                                        style={{ background: "#44b700" }}
                                                                                                    >
                                                                                                          <RecordVoiceOverIcon />
                                                                                                          {"فعال"}
                                                                                                    </Fab>
                                                                                                )}
                                                                                          </TableCell>
                                                                                    </TableRow>
                                                                                )
                                                                          })}
                                                                </TableBody>
                                                          </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[10, 25, 100]}
                                                        component="div"
                                                        count={agentInfofilter.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onChangePage={this.handleChangePage}
                                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                    />
                                              </Paper>
                                        </Container>
                                  </Grid>
                            </Grid>

                            {okstatus ? (
                                <Alert severity="success">
                                      <AlertTitle>پیام</AlertTitle>
                                      {errstr}
                                </Alert>
                            ) : null}
                      </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeFieldCompany)
